import { render, staticRenderFns } from "./DataKap.vue?vue&type=template&id=0a7685c1&scoped=true&"
import script from "./DataKap.vue?vue&type=script&lang=js&"
export * from "./DataKap.vue?vue&type=script&lang=js&"
import style0 from "./DataKap.vue?vue&type=style&index=0&id=0a7685c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7685c1",
  null
  
)

export default component.exports